import Campuslist from './Campus.vue'

let a = Object.assign({ Campuslist })
export default a